import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import ImgStepArrrowPcIcon from '@/assets/images/lp/entry/img_step_arrow_pc.svg';
import ImgStepArrrowSpIcon from '@/assets/images/lp/entry/img_step_arrow_sp.svg';
import ImgStepDotIcon from '@/assets/images/lp/entry/img_step_dot_pc.svg';
import bgMainPc from '@/assets/images/top/bg_main_pc.png';
import bgMainSp from '@/assets/images/top/bg_main_sp.png';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Title = styled.h2(() =>
  mq({
    color: defaultTheme.text.default,
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '1.2',
    textAlign: 'center',
  }),
);

export const MainVisualSection = styled.section(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '460px',
    backgroundColor: defaultTheme.color.black,
  }),
);

export const MainVisual = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1040px',
    height: '460px',
    backgroundImage: [
      `url(${bgMainSp})`,
      `url(${bgMainPc})`,
      `url(${bgMainPc})`,
    ],
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '& > div:first-of-type': {
      marginBottom: [
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
        '32px',
      ],
    },
  }),
);

export const RegisterWrapper = styled.div((props: { isTop: boolean }) =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: props.isTop ? `0 ${defaultTheme.spacing.xxl}` : 0,
    '& > span': {
      color: props.isTop ? defaultTheme.text.white : defaultTheme.text.default,
      fontSize: props.isTop
        ? defaultTheme.font.size.s
        : defaultTheme.font.size.m,
      fontWeight: 'bold',
      marginBottom: defaultTheme.spacing.l,
    },
  }),
);

export const LinkButton = styled(Link)(() =>
  mq({
    width: ['100%', '100%', '320px', '320px'],
    maxWidth: '320px',
    padding: defaultTheme.spacing.xxl,
    color: defaultTheme.color.white,
    fontSize: defaultTheme.font.size.xxl,
    fontWeight: 'bold',
    textAlign: 'center',
    display: 'block',
    borderRadius: '36px',
    background: 'linear-gradient(to right, #337ACC, #50CFE6)',
    ...hoverOpacity,
  }),
);

export const CharmSection = styled.section(() =>
  mq({
    padding: `40px ${defaultTheme.spacing.xxl}`,
    '&>h2': {
      marginBottom: ['24px', '24px', '40px', '40px'],
    },
  }),
);

export const CharmWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      '100%',
      '100%',
      'repeat(2, minmax(360px, 508px))',
      'repeat(2, 508px)',
    ],
    gap: defaultTheme.spacing.xxl,
    justifyContent: 'center',
    marginBottom: defaultTheme.spacing.xxl,
  }),
);

export const CharmContent = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.xxl,
    '& > div:first-of-type': {
      marginBottom: defaultTheme.spacing.xxl,
    },
  }),
);

export const CharmHeadlineWrapper = styled.div(() =>
  mq({
    position: 'relative',
    textAlign: 'left',
  }),
);

export const CharmSubHeadline = styled.div(() =>
  mq({
    color: defaultTheme.color.primary,
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.s,
  }),
);

export const CharmHeadLine = styled.h3(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
    lineHeight: '1.5em',
  }),
);

export const CharmPopularImg = styled.img(() =>
  mq({
    position: 'absolute',
    top: '-9px',
    left: '144px',
    width: '72px',
    height: 'auto',
  }),
);

export const CharmDescription = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    textAlign: 'left',
    '& > span': {
      color: defaultTheme.color.primary,
      fontWeight: 'bold',
    },
    '& > a': {
      display: 'block',
      textDecorationLine: 'underline',
      ...hoverOpacity,
    },
  }),
);

export const CharmCaution = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    textAlign: 'center',
    marginTop: defaultTheme.spacing.xxl,
  }),
);

export const CampaignSection = styled.section(() =>
  mq({
    width: '100%',
    backgroundColor: '#FFE100',
    padding: ['40px 0', '40px 0', '64px 0', '64px 0'],
    marginBottom: ['24px', '24px', '48px', '48px'],
  }),
);

export const MeritContent = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'column', 'row', 'row'],
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '1040px',
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.xxl,
    margin: '0 auto',
    '& > div:first-of-type': {
      flexShrink: 0,
      marginRight: [
        '0',
        '0',
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
      ],
      marginBottom: [
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
        '0',
        '0',
      ],
    },
  }),
);

export const MeritHeadLine = styled.h3(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
    lineHeight: '1.5em',
    textAlign: 'left',
  }),
);

export const MeritDescription = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    textAlign: 'left',
  }),
);

export const StepSection = styled.section(() =>
  mq({
    textAlign: 'center',
    backgroundColor: defaultTheme.background.white,
    padding: [
      `40px ${defaultTheme.spacing.l}`,
      `40px ${defaultTheme.spacing.l}`,
      '40px 0',
      '40px 0',
    ],
    marginBottom: [
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
      '80px',
      '80px',
    ],
    '&>h2': {
      marginBottom: [
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
        '40px',
        '40px',
      ],
    },
  }),
);

export const StepWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      'inherit',
      'inherit',
      '184px 64px 184px 64px 184px',
      '184px 96px 184px 96px 184px',
    ],
    gap: ['8px', '8px', '16px', '32px'],
    justifyContent: 'center',
    marginBottom: ['24px', '24px', '32px', '32px'],
  }),
);

export const StepContent = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['row', 'row', 'column', 'column'],
    alignItems: 'center',
    width: ['100%', '100%', '184px', '184px'],
    '& > div:first-of-type': {
      marginBottom: [
        '0',
        '0',
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
      ],
    },
  }),
);

export const StepContentBody = styled.div(() =>
  mq({
    marginLeft: [defaultTheme.spacing.l, defaultTheme.spacing.l, '0', '0'],
    textAlign: ['left', 'left', 'center', 'center'],
  }),
);

export const StepHeadLine = styled.h3(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const StepDescription = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
  }),
);

export const StepDotIconWrapper = styled.div(() =>
  mq({
    display: ['flex', 'flex', 'block', 'block'],
    justifyContent: ['center', 'center', 'inherit', 'inherit'],
    alignItems: ['center', 'center', 'inherit', 'inherit'],
    height: ['24px', '24px', 'inherit', 'inherit'],
    width: ['72px', '72px', 'inherit', 'inherit'],
  }),
);

export const StepDotIcon = styled.i(() =>
  mq({
    display: 'block',
    width: ['24px', '24px', '64px', '96px'],
    height: ['8px', '8px', '12px', '16px'],
    backgroundImage: `url(${ImgStepDotIcon})`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    transform: ['rotateZ(90deg)', 'rotateZ(90deg)', 'inherit', 'inherit'],
    margin: ['0', '0', '96px 0 0', '96px 0 0'],
  }),
);

export const StepArrowIcon = styled.i(() =>
  mq({
    display: 'block',
    width: ['100%', '100%', '745px', '876px'],
    height: '18px',
    backgroundImage: [
      `url(${ImgStepArrrowSpIcon})`,
      `url(${ImgStepArrrowSpIcon})`,
      `url(${ImgStepArrrowPcIcon})`,
      `url(${ImgStepArrrowPcIcon})`,
    ],
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    margin: `0 auto ${defaultTheme.spacing.xxl}`,
  }),
);

export const StepAfterAgeConfirm = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const StepComplete = styled.p(() =>
  mq({
    fontSize: '28px',
    fontWeight: 'bold',
    color: defaultTheme.color.primary,
    marginBottom: '40px',
  }),
);
